import type { Portal } from '@hcc/types';

export interface PrivacyNoticeCopy {
  /** What is processed and why. */
  processing: string;
  /** How long it is kept. */
  retention: string;
  /** How to exercise access / correction / erasure, and who to ask. */
  rights: string;
}

/**
 * Wording for the first-login privacy acknowledgement, per portal. The
 * main copy describes the mobilisation day (kit, signatures, coordinator).
 * Existing staff on the training portal never see any of that, so their
 * notice talks only about training records and points them at HR. Both
 * follow the retention policy in CLAUDE.md section 10.
 */
export function privacyNoticeCopy(portal: Portal): PrivacyNoticeCopy {
  if (portal === 'training') {
    return {
      processing:
        'Corrigenda processes your personal data (name, email, position, training ' +
        'attempts, scores and certificates) to deliver and record your training and ' +
        'meet our compliance obligations.',
      retention:
        'Training records and certificates are retained for up to 7 years for audit.',
      rights:
        'You can request a copy of your data, correction, or erasure at any time by ' +
        'contacting HR.',
    };
  }
  return {
    processing:
      'Corrigenda processes your personal data (name, email, position, kit issued, ' +
      'signatures) to run on-site induction, issue PPE and equipment, and meet our ' +
      'compliance obligations.',
    retention:
      'Event records (including signatures and asset issuances) are retained for up to ' +
      '7 years for audit. Other personal fields are archived 12 months after the ' +
      'mobilisation closes.',
    rights:
      'You can request a copy of your data, correction, or erasure at any time by ' +
      'contacting your coordinator.',
  };
}
